import { Box, Flex, FlexProps, Text } from '@chakra-ui/react';
import { ButtonText, Button } from '@morressier/alembic';

export const InvitationMessage: React.FC<FlexProps> = ({ ...props }) => (
  <Flex
    borderWidth="1px"
    borderStyle="solid"
    borderColor="neutralSecondaryBorder"
    borderRadius="small"
    backgroundColor="surfaceSecondaryFill"
    padding={4}
    flexDirection="column"
    gap={2}
    {...props}
  >
    <Text>Dear _first_name_ _last_name_,</Text>
    <Text>I hope this message finds you well.</Text>
    <Text>
      My name is _your-name_, and I am the _your-position_ at _journal_name_, an
      open access journal dedicated to advancing knowledge and fostering
      innovation within the _subject_ community.
    </Text>
    <Text>
      We are currently in the process of curating articles for an upcoming issue
      and are seeking experts in _keyword_, _keyword_, and _keyword_ to provide
      valuable insights through peer review.
    </Text>
    <Text>
      Given your esteemed research and contributions to _subject_, we believe
      your expertise would greatly enhance the quality of our publication.
    </Text>
    <Text textStyle="headingLine">What’s Needed:</Text>
    <Box>
      <ul>
        <Text>
          <li>Review of manuscript(s) in your field.</li>
        </Text>
        <Text>
          <li>Completion of review within [x] weeks.</li>
        </Text>
      </ul>
    </Box>
    <Text textStyle="headingLine">Benefits:</Text>
    <Box>
      <ul>
        <Text>
          <li>Engage with the latest research.</li>
        </Text>
        <Text>
          <li>Support the integrity of scholarly work.</li>
        </Text>
      </ul>
    </Box>
    <Text>Abstract:</Text>
    <Text>
      This study presents the findings of a series of interviews conducted with
      17 Italian academic experts in the field of physics. The interviews aimed
      at exploring various aspects of teaching quantum physics (QP) at the...
    </Text>
  </Flex>
);

const InvitationPreview = () => {
  return (
    <Box minHeight="100vh" py={8} backgroundColor="surfaceSecondaryFill">
      <Box
        maxWidth="960px"
        marginX="auto"
        padding={8}
        backgroundColor="surfacePrimaryFill"
        borderRadius="base"
        boxShadow="elevation1"
      >
        <Flex flexDirection="column" gap={4}>
          <Text textStyle="headingOverline">PREVIEW</Text>

          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingLine">Subject</Text>
            <Text>Invitation to Join Peer Review Panel for journal_name</Text>
          </Flex>

          <Flex flexDirection="column" gap={2}>
            <Text textStyle="headingLine">Message</Text>
            <Flex
              borderWidth="1px"
              borderStyle="solid"
              borderColor="neutralSecondaryBorder"
              borderRadius="small"
              backgroundColor="surfaceSecondaryFill"
              padding={4}
              flexDirection="column"
              gap={2}
            >
              <Text>Dear _first_name_ _last_name_,</Text>
              <Text>I hope this message finds you well.</Text>
              <Text>
                My name is _your-name_, and I am the _your-position_ at
                _journal_name_, an open access journal dedicated to advancing
                knowledge and fostering innovation within the _subject_
                community.
              </Text>
              <Text>
                We are currently in the process of curating articles for an
                upcoming issue and are seeking experts in _keyword_, _keyword_,
                and _keyword_ to provide valuable insights through peer review.
              </Text>
              <Text>
                Given your esteemed research and contributions to _subject_, we
                believe your expertise would greatly enhance the quality of our
                publication.
              </Text>
              <Text textStyle="headingLine">What’s Needed:</Text>
              <Box>
                <ul>
                  <Text>
                    <li>Review of manuscript(s) in your field.</li>
                  </Text>
                  <Text>
                    <li>Completion of review within [x] weeks.</li>
                  </Text>
                </ul>
              </Box>
              <Text textStyle="headingLine">Benefits:</Text>
              <Box>
                <ul>
                  <Text>
                    <li>Engage with the latest research.</li>
                  </Text>
                  <Text>
                    <li>Support the integrity of scholarly work.</li>
                  </Text>
                </ul>
              </Box>
              <Text>Abstract:</Text>
              <Text>
                This study presents the findings of a series of interviews
                conducted with 17 Italian academic experts in the field of
                physics. The interviews aimed at exploring various aspects of
                teaching quantum physics (QP) at the...
              </Text>
            </Flex>
          </Flex>

          <Flex gap={4} justifyContent="flex-end">
            <ButtonText>Close, without Sending</ButtonText>
            <Button variant="primary">Send Invitation</Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default InvitationPreview;
